package fr.manyverse.app.presentation.dice3d

import androidx.compose.ui.graphics.Color

/**
 * Couleurs prédéfinies des dés (corps + glyphes). Préférence cosmétique globale de
 * l'utilisateur, persistée comme la couleur du feutre. Contraste garanti : l'ombrage
 * du rendu ne fait qu'assombrir le corps.
 */
enum class DiceColor(val id: String, val body: Color, val pip: Color) {
    RED("red", Color(0xFFC62828), Color.White),
    IVORY("ivory", Color(0xFFF2EAD8), Color(0xFF222222)),
    OBSIDIAN("obsidian", Color(0xFF23262B), Color.White),
    BLUE("blue", Color(0xFF1E5AA8), Color.White),
    GREEN("green", Color(0xFF2E7D32), Color.White),
    PURPLE("purple", Color(0xFF6A3AB2), Color.White);

    companion object {
        val DEFAULT = RED
        fun fromId(id: String?): DiceColor = entries.firstOrNull { it.id == id } ?: DEFAULT
    }
}
